import { render, staticRenderFns } from "./DiscountCodeForm.vue?vue&type=template&id=5f09c884&scoped=true&"
import script from "./DiscountCodeForm.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09c884",
  null
  
)

export default component.exports